(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pov-pro-4k-editorial"] && !Shopify.designMode) return;
  try {
    
(()=>{const mount=root=>{if(root._povClean)return;const abort=new AbortController(),signal=abort.signal;let raf=0;const reduced=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduced.matches;const reveals=[...root.querySelectorAll('[data-reveal]')],scenes=[...root.querySelectorAll('[data-scene]')];const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-in')}),{threshold:.08});reveals.forEach(el=>io.observe(el));const setMotion=()=>{root.classList.toggle('motion-on',!paused);if(paused)scenes.forEach(s=>s.style.setProperty('--scale',1));};setMotion();reduced.addEventListener('change',()=>{paused=reduced.matches;setMotion()},{signal});const update=()=>{raf=0;const b=root.getBoundingClientRect(),vh=innerHeight;root.style.setProperty('--progress',Math.max(0,Math.min(1,-b.top/Math.max(1,b.height-vh))));if(!paused)scenes.forEach(s=>{const b=s.getBoundingClientRect();if(b.bottom>0&&b.top<vh)s.style.setProperty('--scale',1.02+.08*Math.max(0,Math.min(1,(vh-b.top)/(vh+b.height))))})};const tick=()=>{if(!raf)raf=requestAnimationFrame(update)};addEventListener('scroll',tick,{passive:true,signal});addEventListener('resize',tick,{signal});update();const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')];function select(i){tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i})}tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(i),{signal});t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(n);tabs[n].focus()},{signal})});root.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const el=document.getElementById(a.getAttribute('href').slice(1));if(el){e.preventDefault();el.scrollIntoView({behavior:paused?'auto':'smooth',block:'start'})}},{signal}));let observer;if(root.dataset.afterTrustoo==='true'&&!window.Shopify?.designMode){const place=()=>{const reviews=document.querySelector('#trustoo-widget-wrapper, #vstar-reviews, .trustoo-reviews-wrapper');const wrapper=root.closest('.shopify-section')||root,anchor=reviews?.closest('.shopify-section')||reviews;if(anchor&&!anchor.contains(wrapper)&&!wrapper.contains(anchor)&&anchor.nextElementSibling!==wrapper)anchor.after(wrapper)};place();observer=new MutationObserver(place);observer.observe(document.body,{childList:true,subtree:true})}root._povClean=()=>{abort.abort();io.disconnect();observer?.disconnect();cancelAnimationFrame(raf);delete root._povClean};};document.querySelectorAll('[data-pov-story]').forEach(mount);if(!window.povStoryEvents){window.povStoryEvents=true;document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pov-story]').forEach(mount));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-pov-story]').forEach(r=>r._povClean?.()))}})();


  } catch(e) { console.error(e); }
})();
})();
